import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inventory-issue-resolution" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v(" Home ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "inventoryReservation", params: {} },
              },
            },
            [_vm._v(" Inventory Reservations ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(VBreadcrumbsItem, { attrs: { active: "" } }, [
            _vm._v(" Issues "),
          ]),
        ],
        1
      ),
      _c(
        VTabs,
        {
          attrs: { "background-color": "transparent", grow: "" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            VTab,
            [
              _c(VIcon, { attrs: { left: "", color: "warning" } }, [
                _vm._v("mdi-alert-circle-outline"),
              ]),
              _vm._v(" Needs Review "),
              _vm.needsReviewItems.length > 0
                ? _c(VBadge, {
                    staticClass: "ml-2",
                    attrs: {
                      content: _vm.needsReviewItems.length,
                      color: "warning",
                      inline: "",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            VTab,
            [
              _c(VIcon, { attrs: { left: "", color: "info" } }, [
                _vm._v("mdi-clock-outline"),
              ]),
              _vm._v(" Backorder "),
              _vm.backorderItems.length > 0
                ? _c(VBadge, {
                    staticClass: "ml-2",
                    attrs: {
                      content: _vm.backorderItems.length,
                      color: "info",
                      inline: "",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            VTab,
            [
              _c(VIcon, { attrs: { left: "", color: "success" } }, [
                _vm._v("mdi-check-circle-outline"),
              ]),
              _vm._v(" Recently Resolved "),
              _vm.recentlyResolved.length > 0
                ? _c(VBadge, {
                    staticClass: "ml-2",
                    attrs: {
                      content: _vm.recentlyResolved.length,
                      color: "success",
                      inline: "",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            VTabItem,
            [
              !_vm.issuesProcessed
                ? _c(VProgressLinear, {
                    attrs: { indeterminate: "", color: "warning" },
                  })
                : _vm.needsReviewItems.length === 0
                ? _c(
                    "div",
                    { staticClass: "pa-6 text-center" },
                    [
                      _c(
                        VIcon,
                        { attrs: { large: "", color: "grey lighten-1" } },
                        [_vm._v("mdi-check-all")]
                      ),
                      _c("div", { staticClass: "text-h6 grey--text mt-2" }, [
                        _vm._v(" No issues requiring review "),
                      ]),
                    ],
                    1
                  )
                : _c(
                    VList,
                    { staticClass: "pa-2", attrs: { "three-line": "" } },
                    _vm._l(_vm.needsReviewItems, function (issue) {
                      return _c("issue-card", {
                        key: issue.id,
                        attrs: {
                          issue: issue,
                          "resolving-id": _vm.resolvingId,
                          "resolution-notes": _vm.resolutionNotes,
                        },
                        on: {
                          "update:note": function ($event) {
                            return _vm.updateNote(issue.id, $event)
                          },
                          "resolve-with-location": function ($event) {
                            return _vm.confirmResolveWithLocation(issue)
                          },
                          "resolve-manually": function ($event) {
                            return _vm.confirmResolveManually(issue)
                          },
                          "resolve-with-surplus": function ($event) {
                            return _vm.confirmResolveWithSurplus(issue)
                          },
                          "mark-backorder": function ($event) {
                            return _vm.confirmMarkBackorder(issue)
                          },
                        },
                      })
                    }),
                    1
                  ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              !_vm.issuesProcessed
                ? _c(VProgressLinear, {
                    attrs: { indeterminate: "", color: "info" },
                  })
                : _vm.backorderItems.length === 0
                ? _c(
                    "div",
                    { staticClass: "pa-6 text-center" },
                    [
                      _c(
                        VIcon,
                        { attrs: { large: "", color: "grey lighten-1" } },
                        [_vm._v("mdi-package-variant")]
                      ),
                      _c("div", { staticClass: "text-h6 grey--text mt-2" }, [
                        _vm._v(" No backorder items "),
                      ]),
                    ],
                    1
                  )
                : _c(
                    VList,
                    { staticClass: "pa-2", attrs: { "three-line": "" } },
                    _vm._l(_vm.backorderItems, function (issue) {
                      return _c("issue-card", {
                        key: issue.id,
                        attrs: {
                          issue: issue,
                          "resolving-id": _vm.resolvingId,
                          "resolution-notes": _vm.resolutionNotes,
                        },
                        on: {
                          "update:note": function ($event) {
                            return _vm.updateNote(issue.id, $event)
                          },
                          "resolve-with-location": function ($event) {
                            return _vm.confirmResolveWithLocation(issue)
                          },
                          "resolve-manually": function ($event) {
                            return _vm.confirmResolveManually(issue)
                          },
                          "resolve-with-surplus": function ($event) {
                            return _vm.confirmResolveWithSurplus(issue)
                          },
                          "mark-backorder": function ($event) {
                            return _vm.confirmMarkBackorder(issue)
                          },
                        },
                      })
                    }),
                    1
                  ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _vm.loadingResolved
                ? _c(VProgressLinear, {
                    attrs: { indeterminate: "", color: "success" },
                  })
                : _vm.recentlyResolved.length === 0
                ? _c(
                    "div",
                    { staticClass: "pa-6 text-center" },
                    [
                      _c(
                        VIcon,
                        { attrs: { large: "", color: "grey lighten-1" } },
                        [_vm._v("mdi-history")]
                      ),
                      _c("div", { staticClass: "text-h6 grey--text mt-2" }, [
                        _vm._v(
                          " No recently resolved issues in the last 24 hours "
                        ),
                      ]),
                    ],
                    1
                  )
                : _c(
                    VList,
                    { staticClass: "pa-2", attrs: { "three-line": "" } },
                    _vm._l(_vm.recentlyResolved, function (item) {
                      return _c(
                        VCard,
                        {
                          key: item.id,
                          staticClass: "mb-3",
                          attrs: { outlined: "" },
                        },
                        [
                          _c(
                            VCardTitle,
                            { staticClass: "pb-1" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "issue-link",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openWorksheet(
                                        item.processWorksheetId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " Worksheet #" +
                                      _vm._s(
                                        item.worksheetId ||
                                          item.processWorksheetId
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(VSpacer),
                              _c(
                                VChip,
                                {
                                  attrs: {
                                    small: "",
                                    color: "success",
                                    "text-color": "white",
                                  },
                                },
                                [_vm._v(" Resolved ")]
                              ),
                            ],
                            1
                          ),
                          _c(VCardSubtitle, [
                            _vm._v(" " + _vm._s(item.productName) + " "),
                          ]),
                          _c(VCardText, [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-wrap ga-2 mb-2" },
                              [
                                item.processName
                                  ? _c(
                                      VChip,
                                      {
                                        attrs: { "x-small": "", outlined: "" },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.processName) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                item.locationName
                                  ? _c(
                                      VChip,
                                      {
                                        attrs: { "x-small": "", outlined: "" },
                                      },
                                      [
                                        _c(
                                          VIcon,
                                          {
                                            attrs: { "x-small": "", left: "" },
                                          },
                                          [_vm._v("mdi-map-marker")]
                                        ),
                                        _vm._v(
                                          " " + _vm._s(item.locationName) + " "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-caption grey--text" },
                              [
                                item.staffName
                                  ? _c("span", [_vm._v(_vm._s(item.staffName))])
                                  : _vm._e(),
                                item.inventoryDecisionTime
                                  ? _c("span", [
                                      _vm._v(
                                        " — Resolved " +
                                          _vm._s(
                                            _vm._f("formatDateTimeYear")(
                                              item.inventoryDecisionTime
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            item.inventoryDecisionNote
                              ? _c(
                                  "div",
                                  { staticClass: "text-caption mt-1" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.inventoryDecisionNote) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "text-h6" }, [
                _vm._v(" " + _vm._s(_vm.confirmTitle) + " "),
              ]),
              _c(VCardText, [
                _vm._v(" " + _vm._s(_vm.confirmMessage) + " "),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    { attrs: { text: "" }, on: { click: _vm.cancelConfirm } },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        color: _vm.confirmColor,
                        loading: _vm.resolvingId !== null,
                      },
                      on: { click: _vm.executeConfirmedAction },
                    },
                    [_vm._v(" Confirm ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VSnackbar,
        {
          attrs: { color: _vm.snackbar.color, timeout: 4000, top: "" },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar.show = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar.show,
            callback: function ($$v) {
              _vm.$set(_vm.snackbar, "show", $$v)
            },
            expression: "snackbar.show",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }